import Icon from 'shared/components/icon/Icon'

export default Icon
export type { IconName } from './IconName'
